export const timeRegex = /^(([01]\d|2[0-3]):([0-5]\d)|24:00|Gesloten)$/i;
